import { render, staticRenderFns } from "./Sorteo.vue?vue&type=template&id=1b2b8ddc&"
import script from "./Sorteo.vue?vue&type=script&lang=js&"
export * from "./Sorteo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports